import{a as t}from"./chunk-RAAYCPUM.js";function a(...n){return t(o,n)}function o(n){let e=typeof n[0]=="bigint"?1n:1;for(let r of n)e*=r;return e}export{a};
